(function (angular) {
	angular.module('app.offline').config(['$stateProvider', function ($stateProvider) {

		$stateProvider.state('offline', {
			url: '/offline',
            templateUrl: '/app/offline/offline.html'
		});

	}]);

}(angular));

